<template>
    <v-chip
        :color="color"
        class="ml-3"
        :text-color="textColor"
    >
        <v-avatar left v-if="icon">
            <v-icon>{{ icon }}</v-icon>
        </v-avatar>
        {{ orderStatusName }}
    </v-chip>
</template>

<script>
export default {
    name: "OrderStatusChip",

    data () {
        return {
            //TODO: complete colors, textColors, icons
            colors: [
                "green",
            ],
            textColors: [
                "white",
            ],
            icons: [
                "mdi-checkbox-marked-circle",
            ]
        };
    },

    props: {
        orderStatus: Number,
        orderStatusName: String
    },

    computed: {
        color() {
            return this.colors[this.orderStatus] ?? null;
        },
        textColor() {
            return this.textColors[this.orderStatus] ?? null;
        },
        icon() {
            return this.icons[this.orderStatus] ?? null;
        },
    }
}
</script>

<style scoped>

</style>
